import React, { Component } from 'react';
import whyus from "../../../data/whyus.json";

import WhyUs1 from "../../../assets/img/axisdent/acasa/whyus1.jpg"
import WhyUs2 from "../../../assets/img/axisdent/acasa/whyus2.jpg"

const whyUsImages = [WhyUs1, WhyUs2]

class Whyus extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-lg-5 order-2 order-lg-1">
                    <div className="sigma_about style-21">
                        <div className="section-title">
                            <h3 className="title text-white">De ce să alegi clinica <span style={{textDecoration: "underline"}}>AxisDent</span>?</h3>
                        </div>
                        <div className="sigma_about-content">
                            <p>Cabinetul nostru stomatologic se remarcă prin furnizarea de servicii dentare de înaltă calitate, oferite de un personal specializat și prietenos. Ne concentrăm pe confortul și satisfacția pacienților noștri, utilizând cele mai avansate tehnologii și tratamente moderne. </p>
                            {/* Data */}
                            {whyus.slice(0, 2).map((item, i) => (
                                <div className="sigma_info style-15" key={i}>
                                    <div className="sigma_info-title">
                                        <i className={"sigma_info-icon " + item.icon} />
                                    </div>
                                    <div className="sigma_info-description">
                                        <h5>{item.title}</h5>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                            {/* Data */}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 offset-lg-1 order-1 order-lg-2">
                    <div className="sigma_about style-21 mt-0 w-100 h-100">
                        <div className="sigma_about-image-1">
                            <img src={WhyUs2} alt="img" />
                        </div>
                        <div className="sigma_about-image-2 d-none d-sm-block">
                            <img src={WhyUs1} alt="img" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Whyus;
